import {
  Bookmark,
  BookmarkFilled,
  CaretDown,
  CaretUp,
  ChevronRight,
  Renew
} from '@carbon/icons-react'
import { DDSRadio, DDSTooltip, DDSTypography } from 'den-design-system'
import {
  ExceptionStatusTypes,
  SeverityTypes
} from '../../../api/exception/Exception.types'
import React, { useEffect, useRef, useState } from 'react'
import {
  bulkUpdateExceptionsInGroup,
  getExceptionFilters,
  getExceptionLogsOfGroup,
  getStatisticsOfAnExceptionGroupByGroupId,
  updateAnException,
  updateExceptionGroup,
  updateSelectedExceptions,
  viewSingleExceptionGorup
} from '../../../api/exception/Exception.service'
import {
  createSearchParams,
  useNavigate,
  useParams,
  useSearchParams
} from 'react-router-dom'
import {
  formatDateOfDifferentFormat,
  getCommonFilters,
  getOrgTimeRange,
  timeZone
} from '../../../utils/DateTimeUtils'
import {
  getAllQueryParamsAsObjectFromUrl,
  replaceUrl
} from '../../../utils/UrlUtils'
import { isEmpty, toPairs } from 'lodash'

import { Button } from '../../../components/New/Button/Button'
import ConfirmationPopup from '../../../components/common/Exceptions/ConfirmationPopup'
import DocumentHeader from '../../../components/Helmet/DocumentHeader'
import Filter from '../../../components/Filter/Filter'
import GroupedExceptionLogs from './Screens/GroupedExceptionLogs'
import { HeaderConstants } from '../../../constants/HeaderConstants'
import Overview from './Screens/Overview'
import { ProjectType } from '../../../enum/ProjectType.enum'
import SeverityDropDown from '../../../components/common/Exceptions/SeverityDropdown'
import SideChip from '../../../components/New/SideChip/SideChip'
import Spinner from '../../../components/common/Spinner/Spinner'
import StatusDropDown from '../../../components/common/Exceptions/StatusDropdown'
import StringConstants from '../../../constants/StringConstants'
import Tabs from '../../../components/common/DDS/Tabs/Tabs'
import Timezone from '../../../components/common/Timezone/Timezone'
import TimezoneConstants from '../../../constants/TimezoneConstants'
import { ToastMessageConstants } from '../../../constants/ToastMessageConstants'
import ToastNotification from '../../../components/common/DDS/Toast/Toast'
import Tooltip from '../../../components/New/Tooltip/Tooltip'
import UserAvatar from '../../../components/common/UserAvatar/UserAvatar'
import { convertToFormat } from '../../../utils/UCUtils'
import emptyAvatar from '../../../assets/images/EmptyAvatar.svg'
import { gaPageConstants } from '../../../constants/GAConstants'
import { generateRandomId } from '../../../utils/CommonUtils'
import { observer } from 'mobx-react-lite'
import pallete from '../../../global/newPallete'
import routeConstants from '../../../constants/RouteConstants'
import { timeFormats } from '../../../enum/TIME'
import { useAnalyticsEventTracker } from '../../../utils/GAUtils'
import { useStoreContext } from '../../../store/StoreContext'

type SortOrder = 'ASC' | 'DESC' | 'CLEAR'
type SortState = null | SortOrder | 'CLEAR'

const SingleExceptionView: React.FC = () => {
  const store = useStoreContext()
  const [exceptionDetails, setExceptionDetails] = useState<any>()
  const [searchParams, setSearchParams] = useSearchParams()
  const [searchParamsOverview, setSearchParamsOverview] = useSearchParams()
  const [activeTabIndex, setActiveIndex] = useState<string>('1')
  const [modalOpen, setModalOpen] = React.useState<boolean>(false)
  const [preference, setPreference] = React.useState<string>('')
  const [exceptionGroupType, setExceptionGroupType] = React.useState<string>('')
  const [exceptionCount, setExceptionCount] = React.useState<number>()
  const [isloadingTag, setIsLoadingTag] = useState<boolean>(false)
  const [changeToPreference, setToPreference] = React.useState<any>()
  const { id } = useParams()
  const [loading, setLoading] = useState<boolean>(false)
  const [isPopupOpen, setIsPopupOpen] = useState<boolean>(false)
  const [loadingTag, setLoadingTag] = useState<boolean>(false)
  const gaEventTracker = useAnalyticsEventTracker(
    gaPageConstants.REFRESH_EXCEPTIONS_SINGLE_GROUP
  )
  const orgTimeZone = store.userStore.getOrganizationPreference().timeZone
  const organizationPreference =
    store.userStore.getOrganizationPreference()?.timeZone
  const matchedTimeZone = TimezoneConstants.find(
    (tz) => tz?.tzCode === organizationPreference
  )
  const [modalOpenGroup, setModalOpenGroup] = React.useState<boolean>(false)
  const [searchParamsGroup, setSearchParamsGroup] = useSearchParams()
  const [currentGroupId, setCurrentGroupId] = useState<any>('')
  const [preferenceGroup, setPreferenceGroup] = React.useState<string>('')
  const [tableData, setTableData] = useState<any>([])
  const [totalCount, setTotalCount] = useState<number>(0)

  const [currentPage, setCurrentPage] = useState<number>(1)

  const [loadingGroup, setLoadingGroup] = useState<boolean>(true)
  const [loadingDate, setLoadingDate] = useState<boolean>(false)

  const [selectedRows, setSelectedRows] = useState<any>([])
  const [selectedAll, setSelectedAll] = useState<boolean>(false)

  const navigate = useNavigate()

  const isSearchTriggered = useRef(false)

  const [filterOptions, setFilterOptions] = useState<any>([])
  const [filterOptionsOverview, setFilterOptionsOverview] = useState<any>([])
  const [searchTerm, setSearchTerm] = useState('')
  const [showDropdown, setShowDropdown] = useState(false)

  const [searchRecordLength, setSearchRecordLength] = useState<number>(0)
  const [filterLoading, setFilterLoading] = useState<boolean>(false)
  const [filterLoadingOverview, setFilterLoadingOverview] =
    useState<boolean>(false)

  const [activeSortOrder, setActiveSortOrder] = useState<{
    field: string | null
    order: SortOrder | null
  }>(() => {
    const searchParams = new URLSearchParams(window.location.search)

    let sortField: string | null = null
    let sortOrder: SortOrder | null = null

    searchParams.forEach((value, key) => {
      if (key.startsWith('sort-log') && (value === 'ASC' || value === 'DESC')) {
        sortField = key
        sortOrder = value as SortOrder
      }
    })

    return { field: sortField, order: sortOrder }
  })

  useEffect(() => {
    if (activeSortOrder.field && activeSortOrder.order) {
      sortData(activeSortOrder.field, activeSortOrder.order)
    }
  }, [])
  const rowDisabled = useRef(false)

  const [dateFilter, setDateFilter] = useState<any>({})
  const [dateFilterOverview, setDateFilterOverview] = useState<any>({})
  const [applyToExisting, setApplyToExisting] = useState<boolean | null>(null)

  const projectType = store.scopeStore.getSelectedProject().type
  const isFullStackProject = projectType === ProjectType.FULL_STACK_ONLY
  const isSalesforceProject = projectType === ProjectType.SALESFORCE_ONLY

  useEffect(() => {
    sessionStorage.setItem(
      StringConstants.ACTIVE_TAB,
      StringConstants.TAB_VALUES.EXCEPTION
    )
  }, [])

  useEffect(() => {
    const allQueryParams = getAllQueryParamsAsObjectFromUrl(location.search)
    store.exceptionsStoreV2.setActiveGroupedExceptionSeverity(
      allQueryParams['preferredSeverity']
    )
    setPreference(allQueryParams['preferredSeverity'])
  }, [store.exceptionsStoreV2.getActiveGroupedExceptionSeverity()])

  const fetchAnExceptionDetails = () => {
    setLoadingDate(true)
    const allQueryParams = getAllQueryParamsAsObjectFromUrl(location.search)

    const orgTimeZone = store.userStore.getOrganizationPreference()?.timeZone
    const { startOfMonth, endOfCurrentDayTimestamp } =
      getOrgTimeRange(orgTimeZone)

    viewSingleExceptionGorup(
      { $exceptionGroupId: id as string },
      allQueryParams
    )
      .then((response: any) => {
        store.exceptionsStoreV2.setActiveGroupedException(response.data)
        setExceptionGroupType(response.data.exceptionGroupType)
        setExceptionCount(response.data.exceptionCount)
        store.exceptionStore.setIsRefreshed(false)
        setPreference(response.data.preferredSeverity)
        store.exceptionsStoreV2.setActiveGroupedException(response.data)
        store.uiStore.setGlobalLoader(false)

        const filters = getCommonFilters(
          response,
          startOfMonth,
          endOfCurrentDayTimestamp,
          orgTimeZone
        )

        store.filterStore.setFilters(response.filters)
        setDateFilterOverview(filters)
      })
      .catch((error) => {
        ToastNotification({
          type: 'error',
          message: error
        })
      })
      .finally(() => {
        setLoadingDate(false)
      })
  }
  useEffect(() => {
    if (store.exceptionStore.getIsRefreshed()) {
      fetchAnExceptionDetails()
    }
  }, [store.exceptionStore.getIsRefreshed()])

  useEffect(() => {
    sessionStorage.setItem(
      StringConstants.ACTIVE_TAB,
      StringConstants.TAB_VALUES.EXCEPTION
    )
  }, [])

  const handleModalClose = () => {
    setModalOpen(false)
    setApplyToExisting(null)
  }

  useEffect(() => {
    const innerTabIndexFromParams = searchParams.get('groupTab')
    if (innerTabIndexFromParams) {
      setActiveIndex(innerTabIndexFromParams)
    }
    const allQueryParams = getAllQueryParamsAsObjectFromUrl(location.search)
    const orgTimeZone = store.userStore.getOrganizationPreference()?.timeZone

    const { startOfMonth, endOfCurrentDayTimestamp } =
      getOrgTimeRange(orgTimeZone)

    const currentFilters: Record<string, string> = {
      'created-from':
        allQueryParams['created-from'] ||
        sessionStorage.getItem('created-from') ||
        String(startOfMonth),
      'created-to':
        allQueryParams['created-to'] ||
        sessionStorage.getItem('created-to') ||
        String(endOfCurrentDayTimestamp),
      'time-zone':
        allQueryParams['time-zone'] ||
        sessionStorage.getItem('time-zone') ||
        orgTimeZone
    }

    const filterQueryString = new URLSearchParams(currentFilters).toString()

    const tabIndexFromParams = searchParams.get('tab')
    if (!isEmpty(exceptionGroupType)) {
      store.breadcrumbStore.setMultipleBreadcrumbsOptions([
        {
          label: (
            <div
              style={{
                pointerEvents:
                  isloadingTag || store.uiStore.getTagLoader() ? 'none' : 'auto'
              }}
              onClick={(e) => {
                if (loading || isloadingTag || store.uiStore.getTagLoader()) {
                  e.stopPropagation()
                }
              }}
            >
              {store.scopeStore.getSelectedProject().type ===
              ProjectType.FULL_STACK_ONLY
                ? tabIndexFromParams === '1'
                  ? 'Grouped Exceptions'
                  : 'All Exceptions'
                : tabIndexFromParams === '1'
                  ? 'Grouped Errors'
                  : 'All Errors'}
            </div>
          ),
          link:
            routeConstants.EXCEPTIONS +
            `?tab=${tabIndexFromParams}&${filterQueryString}`
        },
        {
          label: (
            <Tooltip
              id={`${exceptionGroupType}`}
              position='bottom'
              className={`max-w-[80%] ${
                typeof exceptionGroupType === 'string' &&
                exceptionGroupType.length > 15
                  ? exceptionGroupType
                  : '!hidden'
              }`}
              label={
                <DDSTypography.Paragraph
                  size='para'
                  variant='regular'
                  color={pallete.colors.primary2}
                  className='max-w-[900px] break-words'
                >
                  {exceptionGroupType}
                </DDSTypography.Paragraph>
              }
            >
              <div
                style={{
                  pointerEvents:
                    isloadingTag || store.uiStore.getTagLoader()
                      ? 'none'
                      : 'auto'
                }}
                onClick={(e) => {
                  if (loading || isloadingTag || store.uiStore.getTagLoader()) {
                    e.stopPropagation()
                  }
                }}
                className='truncate max-w-[200px]'
              >
                {exceptionGroupType}
              </div>
            </Tooltip>
          ),
          link: '/'
        }
      ])
    }
  }, [exceptionGroupType])

  //Severity dropdown change function
  const updateExceptionGroupPreferrence = (severity: SeverityTypes) => {
    const allQueryParams = getAllQueryParamsAsObjectFromUrl(location.search)
    setLoading(true)
    setLoadingTag(true)
    updateExceptionGroup({
      ids: [id as string],
      preferredSeverity: severity
    })
      .then(() => {
        store.exceptionsStoreV2.setActiveGroupedExceptionSeverity(severity)
        ToastNotification({
          type: 'success',
          message: isFullStackProject
            ? ToastMessageConstants.EXCEPTIONS.UPDATE_EXCEPTION_GROUP.SUCCESS
            : ToastMessageConstants.ERROR.UPDATE_ERROR_GROUP.SUCCESS
        })
        setLoading(false)
        setLoadingTag(false)
        setModalOpen(false)
        setApplyToExisting(null)
        if (applyToExisting) {
          const orgTimeZone =
            store.userStore.getOrganizationPreference()?.timeZone
          const payload: any = {
            exceptionGroupId: id as string,
            'created-from': allQueryParams['created-from'],
            'created-to': allQueryParams['created-to'],
            severity: severity as SeverityTypes,
            'time-zone': orgTimeZone
          }
          bulkUpdateExceptionsInGroup(payload).then((response: any) => {
            if (response.data.hasMore) {
              ToastNotification({
                type: 'info',
                message: isFullStackProject
                  ? ToastMessageConstants.EXCEPTIONS
                      .BULK_UPDATE_EXCEPTIONS_IN_GROUP.REMAINING_BATCHES
                  : ToastMessageConstants.ERROR.BULK_UPDATE_ERRORS_IN_GROUP
                      .REMAINING_BATCHES
              })
            } else {
              ToastNotification({
                type: 'success',
                message: isFullStackProject
                  ? ToastMessageConstants.EXCEPTIONS
                      .BULK_UPDATE_EXCEPTIONS_IN_GROUP.SUCCESS
                  : ToastMessageConstants.ERROR.BULK_UPDATE_ERRORS_IN_GROUP
                      .SUCCESS
              })
            }
          })
          fetchAllExceptionLogs({
            ...allQueryParams,
            size: StringConstants.DEFAULT_TABLE_SIZE
          })
        }
        fetchAnExceptionDetails()
      })
      .catch((err) => {
        ToastNotification({
          type: 'error',
          message: isFullStackProject
            ? ToastMessageConstants.EXCEPTIONS.UPDATE_EXCEPTION_GROUP.ERROR
            : ToastMessageConstants.ERROR.UPDATE_ERROR_GROUP.ERROR
        })

        setLoading(false)
        setLoadingTag(false)
        store.filterStore.setFilterDisabled(false)
      })
  }

  //GroupedExceptionTable

  const fetchAllExceptionLogs = (queryParam: any) => {
    setLoadingGroup(true)
    setLoadingDate(true)
    const allQueryParams = getAllQueryParamsAsObjectFromUrl(location.search)
    const searchParams = new URLSearchParams(location.search)

    const urlSortField = searchParams.get('sortField')
    const urlSortOrder = searchParams.get('sortOrder')
    const orgTimeZone = store.userStore.getOrganizationPreference()?.timeZone
    const { startOfMonth, endOfCurrentDayTimestamp } =
      getOrgTimeRange(orgTimeZone)

    const params: any = {
      exceptionGroupId: id,
      'created-from': allQueryParams['created-from'] || String(startOfMonth),
      'created-to':
        allQueryParams['created-to'] || String(endOfCurrentDayTimestamp),
      'time-zone': orgTimeZone,
      ...allQueryParams,
      ...queryParam,
      size: StringConstants.DEFAULT_TABLE_SIZE
    }

    if (urlSortField && urlSortOrder && urlSortOrder !== 'CLEAR') {
      params[urlSortField] = urlSortOrder
    }
    getExceptionLogsOfGroup(params)
      .then((response: any) => {
        if (response.data.length > 0 || store.filterStore.getFiltersApplied()) {
          store.filterStore.setFilterDisabled(false)
        } else {
          store.filterStore.setFilterDisabled(true)
        }
        setTableData(response.data)
        setTotalCount(response.totalCount)

        const filters = getCommonFilters(
          response,
          startOfMonth,
          endOfCurrentDayTimestamp,
          orgTimeZone
        )

        store.filterStore.setFilters(response.filters)
        setDateFilter(filters)
        if (urlSortField && urlSortOrder) {
          setActiveSortOrder({
            field: urlSortField,
            order: urlSortOrder as SortOrder
          })
        }
        store.exceptionStore.setIsRefreshed(false)
        if (response.filters) {
          {
            store.filterStore.setFilters(response.filters)
          }
        } else {
          store.filterStore.setFilters({})
        }
      })
      .catch(() => {
        ToastNotification({
          type: 'error',
          message: ToastMessageConstants.EXCEPTIONS.GET_AN_EXCEPTION.ERROR
        })
      })
      .finally(() => {
        setLoadingDate(false)
        setLoadingGroup(false)
      })
  }

  const sortData = (sortField: string, sortOrder: SortOrder) => {
    const allQueryParams = getAllQueryParamsAsObjectFromUrl(location.search)

    const orgTimeZone = store.userStore.getOrganizationPreference()?.timeZone
    const { startOfMonth, endOfCurrentDayTimestamp } =
      getOrgTimeRange(orgTimeZone)

    setLoadingGroup(true)
    store.uiStore.setGlobalLoader(true)

    const params: any = {
      exceptionGroupId: id,
      'created-from': allQueryParams['created-from'] || String(startOfMonth),
      'created-to':
        allQueryParams['created-to'] || String(endOfCurrentDayTimestamp),
      'time-zone': orgTimeZone,
      ...allQueryParams,
      size: StringConstants.DEFAULT_TABLE_SIZE
    }
    isSearchTriggered.current = true
    Object.keys(params).forEach((key) => {
      if (key.startsWith('sort-')) {
        delete params[key]
      }
    })
    if (sortOrder !== 'CLEAR') {
      params[sortField] = sortOrder

      const searchParams = new URLSearchParams(location.search)
      searchParams.set('sortField', sortField)
      searchParams.set('sortOrder', sortOrder)
      window.history.replaceState({}, '', `?${searchParams.toString()}`)
    } else {
      delete params[sortField]

      const searchParams = new URLSearchParams(location.search)
      searchParams.delete('sortField')
      searchParams.delete('sortOrder')
      window.history.replaceState({}, '', `?${searchParams.toString()}`)
    }

    getExceptionLogsOfGroup(params).then((response: any) => {
      if (response.data.length > 0 || store.filterStore.getFiltersApplied()) {
        store.filterStore.setFilterDisabled(false)
      } else {
        store.filterStore.setFilterDisabled(true)
      }
      setTableData(response.data)
      setTotalCount(response.totalCount)
      setCurrentPage(response.page)
      store.exceptionStore.setIsRefreshed(false)
      if (response.filters) {
        {
          store.filterStore.setFilters(response.filters)
        }
      } else {
        store.filterStore.setFilters({})
      }

      store.uiStore.setGlobalLoader(false)
      setLoadingGroup(false)
    })
  }

  const handleSortCycle = (sortField: string) => {
    let nextOrder: SortOrder = 'ASC'
    if (activeSortOrder.field === sortField) {
      nextOrder =
        activeSortOrder.order === 'ASC'
          ? 'DESC'
          : activeSortOrder.order === 'DESC'
            ? 'CLEAR'
            : 'ASC'
    }

    setActiveSortOrder({
      field: nextOrder !== 'CLEAR' ? sortField : null,
      order: nextOrder
    })

    sortData(sortField, nextOrder)
  }

  const fetchExceptionFilters = () => {
    setFilterLoading(true)
    getExceptionFilters()
      .then((response: any) => {
        setFilterOptions(response.data)
      })
      .catch((err) => {
        ToastNotification({
          type: 'error',
          message: isFullStackProject
            ? ToastMessageConstants.EXCEPTIONS.EXCEPTION_FILTERS.ERROR
            : ToastMessageConstants.ERROR.ERROR_FILTERS.ERROR
        })
      })
      .finally(() => {
        setFilterLoading(false)
      })
  }

  const fetchExceptionFiltersOverview = () => {
    setFilterLoadingOverview(true)
    getExceptionFilters()
      .then((response: any) => {
        const filteredOptions = response.data.filter(
          (item: any) => item?.heading === 'Reported At'
        )
        setFilterOptionsOverview(filteredOptions)
      })
      .catch((err) => {
        ToastNotification({
          type: 'error',
          message: isFullStackProject
            ? ToastMessageConstants.EXCEPTIONS.EXCEPTION_FILTERS.ERROR
            : ToastMessageConstants.ERROR.ERROR_FILTERS.ERROR
        })
      })
      .finally(() => {
        setFilterLoadingOverview(false)
      })
  }

  const updateSeverity = (applyToDefaultGroupSeverity?: boolean) => {
    const allQueryParams = getAllQueryParamsAsObjectFromUrl(location.search)
    const resolvedRows = selectedRows.filter(
      (row: any) => row.exceptionStatus === 'Resolved'
    )
    if (resolvedRows.length > 0) {
      ToastNotification({
        type: 'error',
        message:
          resolvedRows.length === 1
            ? `Update failed. ${resolvedRows.length} selected record has been resolved.`
            : `Update failed. ${resolvedRows.length} selected records have been resolved.`
      })
      setModalOpenGroup(false)
      return
    }

    const isSameSeverity =
      tableData.filter((data: any) => data?.id === currentGroupId)[0]
        ?.severity === preferenceGroup

    if (isSameSeverity) {
      ToastNotification({
        type: 'error',
        message: 'Update failed. The selected severity is already applied.'
      })
      setModalOpenGroup(false)
      return
    }
    if (selectedRows.length === 0 && selectedAll === false) {
      const isSameSeverity =
        tableData.filter((data: any) => data.id === currentGroupId)[0]
          .severity === preferenceGroup
      setLoadingGroup(true)
      if (!isSameSeverity) {
        updateAnException({
          severity: preferenceGroup as SeverityTypes,
          $exceptionLogId: currentGroupId
        })
          .then(() => {
            fetchAllExceptionLogs({
              ...allQueryParams,
              size: StringConstants.DEFAULT_TABLE_SIZE
            })
            ToastNotification({
              type: 'success',
              message: isFullStackProject
                ? ToastMessageConstants.EXCEPTIONS.UPDATE_AN_EXCEPTION.SUCCESS
                : ToastMessageConstants.ERROR.UPDATE_AN_ERROR.SUCCESS
            })
            setCurrentGroupId('')
            setPreferenceGroup('')
            setModalOpenGroup(false)
          })
          .catch(() => {
            ToastNotification({
              type: 'error',
              message: isFullStackProject
                ? ToastMessageConstants.EXCEPTIONS.UPDATE_AN_EXCEPTION.ERROR
                : ToastMessageConstants.ERROR.UPDATE_AN_ERROR.ERROR
            })
            setCurrentGroupId('')
            setPreferenceGroup('')
            setModalOpenGroup(false)
            setLoading(false)
          })
      }
    } else if (selectedAll === true) {
      setLoadingGroup(true)
      const parts = location.pathname.split('/') // splits the string by `/`
      const exceptionGroupId = parts[parts.length - 1]
      const orgTimeZone = store.userStore.getOrganizationPreference()?.timeZone

      const payload: any = {
        exceptionGroupId: exceptionGroupId,
        'created-from': allQueryParams['created-from'],
        'created-to': allQueryParams['created-to'],
        severity: preferenceGroup,
        'time-zone': orgTimeZone
      }

      if (applyToDefaultGroupSeverity) {
        updateExceptionGroup({
          ids: [exceptionGroupId as string],
          preferredSeverity: preferenceGroup as SeverityTypes
        })
          .then(() => {
            store.exceptionsStoreV2.setActiveGroupedExceptionSeverity(
              preference
            )
            setPreference(preference)
            ToastNotification({
              type: 'success',
              message: isFullStackProject
                ? ToastMessageConstants.EXCEPTIONS.UPDATE_AN_EXCEPTION.SUCCESS
                : ToastMessageConstants.ERROR.UPDATE_AN_ERROR.SUCCESS
            })
            fetchAnExceptionDetails()
          })
          .catch((err) => {
            ToastNotification({
              type: 'error',
              message: isFullStackProject
                ? ToastMessageConstants.EXCEPTIONS.UPDATE_AN_EXCEPTION.ERROR
                : ToastMessageConstants.ERROR.UPDATE_AN_ERROR.ERROR
            })
          })
      }

      bulkUpdateExceptionsInGroup(payload)
        .then((response: any) => {
          if (response.data.hasMore) {
            ToastNotification({
              type: 'info',
              message: isFullStackProject
                ? ToastMessageConstants.EXCEPTIONS
                    .BULK_UPDATE_EXCEPTIONS_IN_GROUP.REMAINING_BATCHES
                : ToastMessageConstants.ERROR.BULK_UPDATE_ERRORS_IN_GROUP
                    .REMAINING_BATCHES
            })
          } else {
            ToastNotification({
              type: 'success',
              message: isFullStackProject
                ? ToastMessageConstants.EXCEPTIONS
                    .BULK_UPDATE_EXCEPTIONS_IN_GROUP.SUCCESS
                : ToastMessageConstants.ERROR.BULK_UPDATE_ERRORS_IN_GROUP
                    .SUCCESS
            })
          }
          setPreferenceGroup('')
          setModalOpenGroup(false)
          fetchAllExceptionLogs({
            ...allQueryParams,
            size: StringConstants.DEFAULT_TABLE_SIZE
          })
        })
        .catch((error: any) => {
          ToastNotification({
            type: 'error',
            message: isFullStackProject
              ? ToastMessageConstants.EXCEPTIONS.BULK_UPDATE_EXCEPTIONS_IN_GROUP
                  .ERROR
              : ToastMessageConstants.ERROR.BULK_UPDATE_ERRORS_IN_GROUP.ERROR
          })
          setModalOpenGroup(false)
          setLoadingGroup(false)
        })
    } else {
      const exceptionIds: string[] = []
      selectedRows.forEach((exception: any) => exceptionIds.push(exception.id))
      setLoadingGroup(true)

      updateSelectedExceptions({
        ids: exceptionIds,
        severity: preferenceGroup
      })
        .then(() => {
          ToastNotification({
            type: 'success',
            message: isFullStackProject
              ? ToastMessageConstants.EXCEPTIONS.UPDATE_AN_EXCEPTION.SUCCESS
              : ToastMessageConstants.ERROR.UPDATE_AN_ERROR.SUCCESS
          })
          setCurrentGroupId('')
          setPreferenceGroup('')
          setModalOpenGroup(false)
          setSelectedRows([])
          fetchAllExceptionLogs({
            ...allQueryParams,
            size: StringConstants.DEFAULT_TABLE_SIZE
          })
        })

        .catch((err: any) => {
          ToastNotification({
            type: 'error',
            message: isFullStackProject
              ? ToastMessageConstants.EXCEPTIONS.UPDATE_AN_EXCEPTION.ERROR
              : ToastMessageConstants.ERROR.UPDATE_AN_ERROR.ERROR
          })
          setModalOpenGroup(false)
          setLoadingGroup(false)
        })
    }
  }
  const updateStatus = (id: string, status: ExceptionStatusTypes) => {
    const allQueryParams = getAllQueryParamsAsObjectFromUrl(location.search)
    if (selectedRows.length === 0 && selectedAll === false) {
      const isSameStatus =
        tableData.filter((data: any) => data.id === id)[0].exceptionStatus ===
        status
      if (!isSameStatus) {
        setLoadingGroup(true)

        updateAnException({
          exceptionStatus: status,
          $exceptionLogId: id
        })
          .then(() => {
            ToastNotification({
              type: 'success',
              message: isFullStackProject
                ? ToastMessageConstants.EXCEPTIONS.UPDATE_AN_EXCEPTION.SUCCESS
                : ToastMessageConstants.ERROR.UPDATE_AN_ERROR.SUCCESS
            })
            fetchAllExceptionLogs({
              ...allQueryParams,
              size: StringConstants.DEFAULT_TABLE_SIZE
            })
          })
          .catch(() => {
            ToastNotification({
              type: 'error',
              message: isFullStackProject
                ? ToastMessageConstants.EXCEPTIONS.UPDATE_AN_EXCEPTION.ERROR
                : ToastMessageConstants.ERROR.UPDATE_AN_ERROR.ERROR
            })
          })
      }
    } else if (selectedAll === true) {
      const parts = location.pathname.split('/') // splits the string by `/`
      const exceptionGroupId = parts[parts.length - 1]
      const orgTimeZone = store.userStore.getOrganizationPreference()?.timeZone

      const payload: any = {
        exceptionGroupId: exceptionGroupId,
        'created-from': allQueryParams['created-from'],
        'created-to': allQueryParams['created-to'],
        exceptionStatus: status,
        'time-zone': orgTimeZone
      }

      bulkUpdateExceptionsInGroup(payload)
        .then((response: any) => {
          fetchAllExceptionLogs({
            ...allQueryParams,
            size: StringConstants.DEFAULT_TABLE_SIZE
          })
          if (response.data.hasMore) {
            ToastNotification({
              type: 'info',
              message: isFullStackProject
                ? ToastMessageConstants.EXCEPTIONS
                    .BULK_UPDATE_EXCEPTIONS_IN_GROUP.REMAINING_BATCHES
                : ToastMessageConstants.ERROR.BULK_UPDATE_ERRORS_IN_GROUP
                    .REMAINING_BATCHES
            })
          } else {
            ToastNotification({
              type: 'success',
              message: isFullStackProject
                ? ToastMessageConstants.EXCEPTIONS
                    .BULK_UPDATE_EXCEPTIONS_IN_GROUP.SUCCESS
                : ToastMessageConstants.ERROR.BULK_UPDATE_ERRORS_IN_GROUP
                    .SUCCESS
            })
          }
        })
        .catch((error: any) => {
          ToastNotification({
            type: 'error',
            message: isFullStackProject
              ? ToastMessageConstants.EXCEPTIONS.BULK_UPDATE_EXCEPTIONS_IN_GROUP
                  .ERROR
              : ToastMessageConstants.ERROR.BULK_UPDATE_ERRORS_IN_GROUP.ERROR
          })
        })
    } else {
      const exceptionIds: string[] = []

      selectedRows.forEach((exception: any) => exceptionIds.push(exception.id))

      setLoadingGroup(true)

      updateSelectedExceptions({
        ids: exceptionIds,
        exceptionStatus: status
      })
        .then(() => {
          ToastNotification({
            type: 'success',
            message: isFullStackProject
              ? ToastMessageConstants.EXCEPTIONS.UPDATE_AN_EXCEPTION.SUCCESS
              : ToastMessageConstants.ERROR.UPDATE_AN_ERROR.SUCCESS
          })

          fetchAllExceptionLogs({
            ...allQueryParams,
            size: StringConstants.DEFAULT_TABLE_SIZE
          })
        })
        .catch(() => {
          ToastNotification({
            type: 'error',
            message: isFullStackProject
              ? ToastMessageConstants.EXCEPTIONS.UPDATE_AN_EXCEPTION.ERROR
              : ToastMessageConstants.ERROR.UPDATE_AN_ERROR.ERROR
          })
          setLoadingGroup(false)
        })
    }
  }
  const updateBookmark = (id: string, bookmarkState: boolean) => {
    const allQueryParams = getAllQueryParamsAsObjectFromUrl(location.search)
    setLoadingGroup(true)
    if (selectedRows.length === 0 && selectedAll === false) {
      const isSameBookmarkState =
        tableData.filter((data: any) => data.id === id)[0].isBookmarked ===
        bookmarkState
      if (!isSameBookmarkState) {
        updateAnException({
          isBookmarked: bookmarkState,
          $exceptionLogId: id
        })
          .then(() => {
            ToastNotification({
              type: 'success',
              message: isFullStackProject
                ? ToastMessageConstants.EXCEPTIONS.UPDATE_AN_EXCEPTION.SUCCESS
                : ToastMessageConstants.ERROR.UPDATE_AN_ERROR.SUCCESS
            })
            fetchAllExceptionLogs({
              ...allQueryParams,
              size: StringConstants.DEFAULT_TABLE_SIZE
            })
          })
          .catch(() => {
            ToastNotification({
              type: 'error',
              message: isFullStackProject
                ? ToastMessageConstants.EXCEPTIONS.UPDATE_AN_EXCEPTION.ERROR
                : ToastMessageConstants.ERROR.UPDATE_AN_ERROR.ERROR
            })
          })
      }
    } else if (selectedAll === true) {
      const parts = location.pathname.split('/') // splits the string by `/`
      const exceptionGroupId = parts[parts.length - 1]
      const orgTimeZone = store.userStore.getOrganizationPreference()?.timeZone

      const payload: any = {
        exceptionGroupId: exceptionGroupId,
        'created-from': allQueryParams['created-from'],
        'created-to': allQueryParams['created-to'],
        isBookmarked: bookmarkState,
        'time-zone': orgTimeZone
      }

      bulkUpdateExceptionsInGroup(payload)
        .then((response: any) => {
          fetchAllExceptionLogs({
            ...allQueryParams,
            size: StringConstants.DEFAULT_TABLE_SIZE
          })
          if (response.data.hasMore) {
            ToastNotification({
              type: 'info',
              message: isFullStackProject
                ? ToastMessageConstants.EXCEPTIONS
                    .BULK_UPDATE_EXCEPTIONS_IN_GROUP.REMAINING_BATCHES
                : ToastMessageConstants.ERROR.BULK_UPDATE_ERRORS_IN_GROUP
                    .REMAINING_BATCHES
            })
          } else {
            ToastNotification({
              type: 'success',
              message: isFullStackProject
                ? ToastMessageConstants.EXCEPTIONS
                    .BULK_UPDATE_EXCEPTIONS_IN_GROUP.SUCCESS
                : ToastMessageConstants.ERROR.BULK_UPDATE_ERRORS_IN_GROUP
                    .SUCCESS
            })
          }
        })
        .catch((error) => {
          ToastNotification({
            type: 'error',
            message: isFullStackProject
              ? ToastMessageConstants.EXCEPTIONS.BULK_UPDATE_EXCEPTIONS_IN_GROUP
                  .ERROR
              : ToastMessageConstants.ERROR.BULK_UPDATE_ERRORS_IN_GROUP.ERROR
          })
        })
    } else {
      const exceptionIds: string[] = []
      selectedRows.forEach((exception: any) => exceptionIds.push(exception.id))
      setLoadingGroup(true)
      updateSelectedExceptions({
        ids: exceptionIds,
        isBookmarked: bookmarkState
      })
        .then(() => {
          ToastNotification({
            type: 'success',
            message: isFullStackProject
              ? ToastMessageConstants.EXCEPTIONS.UPDATE_AN_EXCEPTION.SUCCESS
              : ToastMessageConstants.ERROR.UPDATE_AN_ERROR.SUCCESS
          })

          fetchAllExceptionLogs({
            ...allQueryParams,
            size: StringConstants.DEFAULT_TABLE_SIZE
          })
        })
        .catch((err: any) => {
          ToastNotification({
            type: 'error',
            message: isFullStackProject
              ? ToastMessageConstants.EXCEPTIONS.UPDATE_AN_EXCEPTION.ERROR
              : ToastMessageConstants.ERROR.UPDATE_AN_ERROR.ERROR
          })
        })
    }
  }
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.slice(0, 50)
    const allQueryParams = getAllQueryParamsAsObjectFromUrl(location.search)
    if (value === '' && allQueryParams['search-string']) {
      setSearchTerm('')
      setShowDropdown(false)
      setCurrentPage(currentPage)

      const orgTimeZone = store.userStore.getOrganizationPreference()?.timeZone
      const { startOfMonth, endOfCurrentDayTimestamp } =
        getOrgTimeRange(orgTimeZone)

      const params = {
        exceptionGroupId: id,
        ...allQueryParams,
        size: StringConstants.DEFAULT_TABLE_SIZE,
        page: currentPage,
        'created-from': allQueryParams['created-from'] || startOfMonth,
        'created-to': allQueryParams['created-to'] || endOfCurrentDayTimestamp,
        'time-zone': orgTimeZone
      }

      delete params['search-string']
      delete params['search-type']
      setSearchParamsGroup({ ...params, searchTerm: '' })

      setLoadingGroup(true)
      store.uiStore.setGlobalLoader(true)
      isSearchTriggered.current = true

      getExceptionLogsOfGroup(params)
        .then((response: any) => {
          setTableData(response.data)
          setCurrentPage(response.page)
          setTotalCount(response.totalCount)
        })
        .catch((e) => {
          ToastNotification({
            type: 'error',
            message: isFullStackProject
              ? ToastMessageConstants.EXCEPTIONS.GROUP_LOG_SEARCH.ERROR
              : ToastMessageConstants.ERROR.GET_ALL_ERROR.ERROR
          })
        })
        .finally(() => {
          store.uiStore.setGlobalLoader(false)
          setLoadingGroup(false)
        })
    }

    const isValidInput = /^[\w\s!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]*$/.test(
      value
    )
    if (!isValidInput) {
      return
    }
    setSearchTerm(value)
    if (value.trim()) {
      setShowDropdown(true)
    }
  }

  const handleOptionSelect = (searchString: string, searchType: string) => {
    setLoadingGroup(true)
    store.uiStore.setGlobalLoader(true)
    setCurrentPage(1)

    const allQueryParams = getAllQueryParamsAsObjectFromUrl(location.search)
    const params: any = {
      exceptionGroupId: id,
      ...allQueryParams,
      size: StringConstants.DEFAULT_TABLE_SIZE,
      'search-string': searchString,
      'search-type': searchType,
      page: 1
    }

    setSearchParamsGroup({ ...params, searchTerm: searchTerm })
    isSearchTriggered.current = true
    getExceptionLogsOfGroup(params)
      .then((response: any) => {
        setTableData(response.data)
        setCurrentPage(response.page)
        setSearchRecordLength(response.totalCount)
        setTotalCount(response.totalCount)
      })
      .catch((e) => {
        ToastNotification({
          type: 'error',
          message: isFullStackProject
            ? ToastMessageConstants.EXCEPTIONS.GROUP_LOG_SEARCH.ERROR
            : ToastMessageConstants.ERROR.GET_ALL_ERROR.ERROR
        })
      })
      .finally(() => {
        store.uiStore.setGlobalLoader(false)
        setLoadingGroup(false)
      })

    setShowDropdown(false)
  }

  const handleSearchEnter = (searchValue: string) => {
    if (!searchValue || searchValue.trim() === '') {
      return
    }
    setLoadingGroup(true)
    store.uiStore.setGlobalLoader(true)
    setCurrentPage(1)

    const allQueryParams = getAllQueryParamsAsObjectFromUrl(location.search)
    const params = {
      exceptionGroupId: id,
      ...allQueryParams,
      'search-string': searchValue || '',
      'search-type': 'any',
      page: 1,
      size: StringConstants.DEFAULT_TABLE_SIZE
    }
    isSearchTriggered.current = true
    setSearchParamsGroup({ ...params, searchTerm: searchTerm })

    getExceptionLogsOfGroup(params)
      .then((response: any) => {
        setTableData(response.data)
        setSearchRecordLength(response.totalCount)
        setCurrentPage(response.page)
        setTotalCount(response.totalCount)
      })
      .catch((error: any) => {
        ToastNotification({
          type: 'error',
          message: isFullStackProject
            ? ToastMessageConstants.EXCEPTIONS.GROUP_LOG_SEARCH.ERROR
            : ToastMessageConstants.ERROR.GET_ALL_ERROR.ERROR
        })
      })
      .finally(() => {
        store.uiStore.setGlobalLoader(false)
        setLoadingGroup(false)
      })

    setShowDropdown(false)
  }

  const routeExceptionLog = (id: number, type: string) => {
    if (!rowDisabled.current) {
      store.exceptionStore.setId(id.toString())
      store.exceptionStore.setType(type)

      const orgTimeZone = store.userStore.getOrganizationPreference()?.timeZone

      const { startOfMonth, endOfCurrentDayTimestamp } =
        getOrgTimeRange(orgTimeZone)

      const searchParams = new URLSearchParams(window.location.search)
      const currentFilters: Record<string, string> = {}

      ;(currentFilters['created-from'] =
        searchParams.get('created-from') || String(startOfMonth)),
        (currentFilters['created-to'] =
          searchParams.get('created-to') || String(endOfCurrentDayTimestamp)),
        (currentFilters['time-zone'] =
          searchParams.get('time-zone') || orgTimeZone)

      if (searchParams.get('assigned-to')) {
        currentFilters['assigned-to'] = searchParams.get('assigned-to') || ''
      }

      const route = replaceUrl(
        routeConstants.ERROR_DETAILS,
        store.scopeStore.getScope()['organization-id'] as string,
        store.scopeStore.getScope()['project-id'] as string,
        store.scopeStore.getScope()['environment-id'] as string
      ).replace(':id', String(id))
      const queryParams = {
        tab: searchParams.get('tab') as string,
        innerTab: searchParams.get('innerTab') as string,
        ...currentFilters
      }
      navigate({
        pathname: route,
        search: `?${createSearchParams(queryParams)}`
      })
    }
  }

  const LogTableColumns = [
    {
      heading: '',
      dataLabel: '',
      render: (text: any, fullItem: any) => {
        const isDropdownDisabled =
          selectedRows.length > 0 &&
          !selectedRows.some(
            (selectedRow: any) => selectedRow.id === fullItem.id
          )
        return (
          <Tooltip
            id={generateRandomId()}
            label={fullItem['isBookmarked'] ? 'Bookmarked' : 'Bookmark'}
          >
            <div
              onClick={() => {
                rowDisabled.current = true
                setTimeout(() => {
                  rowDisabled.current = false
                }, 2000)
                if (!isDropdownDisabled) {
                  updateBookmark(fullItem['id'], !fullItem['isBookmarked'])
                }
              }}
              className={`${isDropdownDisabled} ? 'cursor-none' : 'cursor-pointer'`}
            >
              {fullItem['isBookmarked'] ? (
                <BookmarkFilled color={pallete.colors.primary2} />
              ) : (
                <Bookmark color={pallete.colors.stroke4} />
              )}
            </div>
          </Tooltip>
        )
      }
    },

    {
      heading: (
        <div className='flex whitespace-nowrap space-x-[8px] items-center'>
          <div>
            <DDSTypography.Paragraph
              variant='semiBold'
              size='caption'
              className='text-start flex whitespace-nowrap'
              color={pallete.colors.textDark6}
            >
              {isFullStackProject ? 'Exception Message' : 'Error Message'}
            </DDSTypography.Paragraph>
          </div>
          <div
            className='flex flex-col justify-center -space-y-[6px]'
            onClick={() => handleSortCycle('sort-log-exception-message')}
          >
            <CaretUp
              size={12}
              style={{
                color:
                  activeSortOrder.field === 'sort-log-exception-message' &&
                  activeSortOrder.order === 'ASC'
                    ? pallete.colors.FillButton
                    : activeSortOrder.field === 'sort-log-exception-message' &&
                        activeSortOrder.order === 'DESC'
                      ? pallete.colors.outButtonDis
                      : pallete.colors.textDark6
              }}
              className='cursor-pointer'
            />
            <CaretDown
              size={12}
              style={{
                color:
                  activeSortOrder.field === 'sort-log-exception-message' &&
                  activeSortOrder.order === 'ASC'
                    ? pallete.colors.outButtonDis
                    : activeSortOrder.field === 'sort-log-exception-message' &&
                        activeSortOrder.order === 'DESC'
                      ? pallete.colors.FillButton
                      : pallete.colors.textDark6
              }}
              className='cursor-pointer'
            />
          </div>
        </div>
      ),
      dataLabel: 'exceptionMessage',
      render: (text: any) => (
        <DDSTooltip
          id={generateRandomId()}
          label={text}
          shape='roundedRectangle'
          theme='light'
          className={`border override-tooltip-arrow max-w-[90%] break-all ${
            typeof text === 'string' && text.length > 15 ? text : '!hidden'
          }`}
          style={{
            borderColor: pallete.colors.stroke2,
            zIndex: 99999
          }}
        >
          <div className='flex justify-center text-center row items-center'>
            <DDSTypography.Paragraph
              variant='medium'
              size='para'
              className='text-center truncate  max-w-[180px] cursor-default'
            >
              {text}
            </DDSTypography.Paragraph>
          </div>
        </DDSTooltip>
      )
    },
    ...(isFullStackProject
      ? [
          {
            columnHeaderStyle: { width: '250px' },
            columnDataStyle: { width: '250px' },
            heading: (
              <div className='flex whitespace-nowrap justify-center space-x-[8px] items-center'>
                <div>
                  <DDSTypography.Paragraph
                    variant='semiBold'
                    size='caption'
                    className='text-center flex whitespace-nowrap'
                    color={pallete.colors.textDark6}
                  >
                    Client Version
                  </DDSTypography.Paragraph>
                </div>
                <div
                  className='flex flex-col justify-center -space-y-[6px]'
                  onClick={() =>
                    handleSortCycle('sort-log-exception-client-version')
                  }
                >
                  <CaretUp
                    size={12}
                    style={{
                      color:
                        activeSortOrder.field ===
                          'sort-log-exception-client-version' &&
                        activeSortOrder.order === 'ASC'
                          ? pallete.colors.FillButton
                          : activeSortOrder.field ===
                                'sort-log-exception-client-version' &&
                              activeSortOrder.order === 'DESC'
                            ? pallete.colors.outButtonDis
                            : pallete.colors.textDark6
                    }}
                    className='cursor-pointer'
                  />
                  <CaretDown
                    size={12}
                    style={{
                      color:
                        activeSortOrder.field ===
                          'sort-log-exception-client-version' &&
                        activeSortOrder.order === 'ASC'
                          ? pallete.colors.outButtonDis
                          : activeSortOrder.field ===
                                'sort-log-exception-client-version' &&
                              activeSortOrder.order === 'DESC'
                            ? pallete.colors.FillButton
                            : pallete.colors.textDark6
                    }}
                    className='cursor-pointer'
                  />
                </div>
              </div>
            ),
            dataLabel: 'clientVersion',
            render: (text: any) => (
              <div className='flex justify-center'>
                <DDSTypography.Paragraph
                  variant='medium'
                  size='para'
                  className='text-center  whitespace-nowrap'
                >
                  {text ? text : '-'}
                </DDSTypography.Paragraph>
              </div>
            )
          }
        ]
      : []),
    {
      columnHeaderStyle: { width: '160px' },
      columnDataStyle: { width: '160px' },
      heading: (
        <div className='flex whitespace-nowrap justify-center space-x-[8px] items-center'>
          <div>
            <DDSTypography.Paragraph
              variant='semiBold'
              size='caption'
              className='text-center flex whitespace-nowrap'
              color={pallete.colors.textDark6}
            >
              Reported at
            </DDSTypography.Paragraph>
          </div>
          <div
            className='flex flex-col justify-center -space-y-[6px]'
            onClick={() => handleSortCycle('sort-log-reported-time')}
          >
            <CaretUp
              size={12}
              style={{
                color:
                  activeSortOrder.field === 'sort-log-reported-time' &&
                  activeSortOrder.order === 'ASC'
                    ? pallete.colors.FillButton
                    : activeSortOrder.field === 'sort-log-reported-time' &&
                        activeSortOrder.order === 'DESC'
                      ? pallete.colors.outButtonDis
                      : pallete.colors.textDark6
              }}
              className='cursor-pointer'
            />
            <CaretDown
              size={12}
              style={{
                color:
                  activeSortOrder.field === 'sort-log-reported-time' &&
                  activeSortOrder.order === 'ASC'
                    ? pallete.colors.outButtonDis
                    : activeSortOrder.field === 'sort-log-reported-time' &&
                        activeSortOrder.order === 'DESC'
                      ? pallete.colors.FillButton
                      : pallete.colors.textDark6
              }}
              className='cursor-pointer'
            />
          </div>
        </div>
      ),
      dataLabel: 'reportedAt',
      render: (text: any) => (
        <DDSTooltip
          id={`${text}`}
          label={
            <DDSTypography.Paragraph
              size='para'
              variant='regular'
              color={pallete.colors.textDark4}
            >
              {timeZone(
                store.userStore.getOrganizationPreference().timeZone,
                text,
                timeFormats.fullMonthDateYearTime
              )}
            </DDSTypography.Paragraph>
          }
          shape='roundedRectangle'
          position='top'
          className={`override-tooltip-arrow ${
            typeof text === 'string' && text.length > 24 ? text : '!hidden'
          }`}
          style={{
            backgroundColor: pallete.colors.surface1,
            zIndex: 999999
          }}
        >
          <div className='flex justify-center text-center row items-center'>
            <DDSTypography.Paragraph
              variant='medium'
              size='para'
              className='tooltip-container sm:block overflow-hidden truncate max-w-[160px]'
            >
              {timeZone(
                store.userStore.getOrganizationPreference().timeZone,
                text,
                timeFormats.fullMonthDateYearTime
              )}
            </DDSTypography.Paragraph>
          </div>
        </DDSTooltip>
      )
    },
    {
      heading: (
        <DDSTypography.Paragraph
          variant='semiBold'
          size='caption'
          className='text-center whitespace-nowrap flex justify-center'
          color={pallete.colors.textDark6}
        >
          Assigned To
        </DDSTypography.Paragraph>
      ),
      dataLabel: 'assignedTo',
      render: (text: any, fullItem: any) => {
        const assignedTo = fullItem.assignedTo

        // Normalize assignedTo into an array
        const assignedArray = Array.isArray(assignedTo)
          ? assignedTo
          : assignedTo
            ? [assignedTo]
            : []

        const imageGroup = assignedArray.map((item: any) => ({
          name: `${item.user.firstName} ${item.user.lastName}`,
          avatar: item.user.avatar,
          firstName: item.user.firstName,
          lastName: item.user.lastName
        }))

        return (
          <div className='flex flex-row justify-center w-full'>
            {assignedArray.length === 1 ? (
              <UserAvatar
                avatarType='Single'
                imageUrl={assignedArray[0].user.avatar}
                name={`${assignedArray[0].user.firstName} ${assignedArray[0].user.lastName}`}
                firstName={assignedArray[0].user.firstName}
                lastName={assignedArray[0].user.lastName}
              />
            ) : assignedArray.length > 1 ? (
              <UserAvatar avatarType='Multiple' imageObjectGroup={imageGroup} />
            ) : (
              <img
                src={emptyAvatar}
                className='rounded-full h-[24px] w-[24px]'
              />
            )}
          </div>
        )
      }
    },
    {
      heading: (
        <div className='flex whitespace-nowrap justify-center space-x-[8px] items-center'>
          <div>
            <DDSTypography.Paragraph
              variant='semiBold'
              size='caption'
              className='text-center flex whitespace-nowrap'
              color={pallete.colors.textDark6}
            >
              Severity
            </DDSTypography.Paragraph>
          </div>
          <div
            className='flex flex-col justify-center -space-y-[6px]'
            onClick={() => handleSortCycle('sort-log-preferred-severity')}
          >
            <CaretUp
              size={12}
              style={{
                color:
                  activeSortOrder.field === 'sort-log-preferred-severity' &&
                  activeSortOrder.order === 'ASC'
                    ? pallete.colors.FillButton
                    : activeSortOrder.field === 'sort-log-preferred-severity' &&
                        activeSortOrder.order === 'DESC'
                      ? pallete.colors.outButtonDis
                      : pallete.colors.textDark6
              }}
              className='cursor-pointer'
            />
            <CaretDown
              size={12}
              style={{
                color:
                  activeSortOrder.field === 'sort-log-preferred-severity' &&
                  activeSortOrder.order === 'ASC'
                    ? pallete.colors.outButtonDis
                    : activeSortOrder.field === 'sort-log-preferred-severity' &&
                        activeSortOrder.order === 'DESC'
                      ? pallete.colors.FillButton
                      : pallete.colors.textDark6
              }}
              className='cursor-pointer'
            />
          </div>
        </div>
      ),
      dataLabel: 'severity',
      render: (text: any, fullItem: any) => {
        const isDropdownDisabled =
          selectedRows.length > 0 &&
          !selectedRows.some(
            (selectedRow: any) => selectedRow.id === fullItem.id
          )
        const setSeverity = (severity: SeverityTypes) => {
          setCurrentGroupId(fullItem['id'])
          setPreferenceGroup(severity)
          if (selectedRows.length === 0 && fullItem['severity'] !== severity) {
            setModalOpenGroup(true)
          } else if (selectedRows.length > 0) {
            setModalOpenGroup(true)
          }
        }
        return (
          <div className=' flex justify-center items-center '>
            <SeverityDropDown
              label={text}
              onSelect={setSeverity}
              disabled={
                fullItem.exceptionStatus === 'Resolved' || isDropdownDisabled
              }
              disableNoSubscription={
                store.userStore.getNoActiveSubscription() ||
                loading ||
                store.uiStore.getGlobalLoader()
              }
            />
          </div>
        )
      }
    },
    {
      heading: (
        <div className='flex whitespace-nowrap justify-center space-x-[8px] items-center'>
          <div>
            <DDSTypography.Paragraph
              variant='semiBold'
              size='caption'
              className='text-center flex whitespace-nowrap'
              color={pallete.colors.textDark6}
            >
              Status
            </DDSTypography.Paragraph>
          </div>
          <div
            className='flex flex-col justify-center -space-y-[6px]'
            onClick={() => handleSortCycle('sort-log-exception-status')}
          >
            <CaretUp
              size={12}
              style={{
                color:
                  activeSortOrder.field === 'sort-log-exception-status' &&
                  activeSortOrder.order === 'ASC'
                    ? pallete.colors.FillButton
                    : activeSortOrder.field === 'sort-log-exception-status' &&
                        activeSortOrder.order === 'DESC'
                      ? pallete.colors.outButtonDis
                      : pallete.colors.textDark6
              }}
              className='cursor-pointer'
            />
            <CaretDown
              size={12}
              style={{
                color:
                  activeSortOrder.field === 'sort-log-exception-status' &&
                  activeSortOrder.order === 'ASC'
                    ? pallete.colors.outButtonDis
                    : activeSortOrder.field === 'sort-log-exception-status' &&
                        activeSortOrder.order === 'DESC'
                      ? pallete.colors.FillButton
                      : pallete.colors.textDark6
              }}
              className='cursor-pointer'
            />
          </div>
        </div>
      ),
      dataLabel: 'exceptionStatus',
      render: (text: any, fullItem: any) => {
        const isDropdownDisabled =
          selectedRows.length > 0 &&
          !selectedRows.some(
            (selectedRow: any) => selectedRow.id === fullItem.id
          )
        const setStatus = (status: ExceptionStatusTypes) => {
          if (!isDropdownDisabled) {
            updateStatus(fullItem['id'], status)
          }
        }
        return (
          <div
            className={`flex justify-center items-center ${isDropdownDisabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
          >
            <StatusDropDown
              label={text}
              onSelect={setStatus}
              disabled={
                isDropdownDisabled ||
                store.userStore.getNoActiveSubscription() ||
                loading ||
                store.uiStore.getGlobalLoader()
              }
            />
          </div>
        )
      }
    },
    {
      columnHeaderStyle: { width: '20px' },
      columnDataStyle: { width: '20px' },
      heading: '',
      dataLabel: '',
      render: (text: any, fullItem: any) => {
        const isDropdownDisabled =
          selectedRows.length > 0 &&
          !selectedRows.some(
            (selectedRow: any) => selectedRow.id === fullItem.id
          )
        return (
          <div>
            <ChevronRight
              size={16}
              color={pallete.colors.primary2}
              className={`${isDropdownDisabled} ? 'cursor-none' : 'cursor-pointer'`}
              onClick={() => {
                if (isDropdownDisabled) return

                const params = Object.fromEntries(searchParams.entries())
                const {
                  groupTab: groupTab,
                  'created-from': createdFrom,
                  'created-to': createdTo,
                  'time-zone': timeZone,
                  'is-bookmarked': isBookmarked,
                  severity: severity,
                  'exception-status': exceptionStatus,
                  'assigned-to': assignedTo
                } = params

                sessionStorage.setItem('exceptionGroupTab', '2')
                sessionStorage.setItem('created-from', createdFrom || '')
                sessionStorage.setItem('created-to', createdTo || '')
                sessionStorage.setItem('time-zone', timeZone || '')

                if (groupTab === '2') {
                  sessionStorage.setItem('is-bookmarked', isBookmarked || '')
                  sessionStorage.setItem('severity', severity || '')
                  sessionStorage.setItem(
                    'exception-status',
                    exceptionStatus || ''
                  )
                  sessionStorage.setItem('assigned-to', assignedTo || '')
                }

                routeExceptionLog(fullItem.id, fullItem.exceptionType)
              }}
            />
          </div>
        )
      }
    }
  ]

  //Overview

  const [firstReported, setFirstReported] = useState<string>('')
  const [avgPerDay, setAvgPerDay] = useState<any>()
  const [lastReported, setLastReported] = useState<string>('')
  const [maximumReport, setMaximumReport] = useState<string>('')
  const [loadingOverview, setLoadingOverview] = useState<boolean>(true)
  const [stockChartData, setStockChartData] = useState<any>({})
  const [doughnutChartData, setDoughnutChartData] = useState<any>([])

  const fetchExceptionStatistics = async () => {
    setLoadingOverview(true)
    setLoadingTag(true)

    const exceptionGroupId = location.pathname.split('/').includes('grouped')
      ? store.exceptionsStoreV2.getCurrentExceptionId()
      : id

    const allQueryParams = getAllQueryParamsAsObjectFromUrl(location.search)

    try {
      const response: any = await getStatisticsOfAnExceptionGroupByGroupId(
        { $exceptionGroupId: exceptionGroupId as string },
        allQueryParams
      )

      // Updating all local states
      setFirstReported(response.data?.firstReportedTime)
      setLastReported(response.data?.latestReportedTime)
      setAvgPerDay(response.data?.averageReported)
      setMaximumReport(
        Object.values(response.data?.maximumReportedInADay)[0] as string
      )
      setStockChartData(
        toPairs(response.data?.responsesByInterval).map(([key, value]) => {
          key = formatDateOfDifferentFormat(key, 'DD/MM/YYYY', 'YYYY-MM-DD')
          return [Number(new Date(key).getTime()), value]
        })
      )

      const messagesLabels = [
        response?.data?.mostOccurredExceptionMessage?.message !== '-'
          ? response?.data?.mostOccurredExceptionMessage?.message
          : null,
        response?.data?.secondMostOccurredExceptionMessage?.message !== '-'
          ? response?.data?.secondMostOccurredExceptionMessage?.message
          : null,
        'Others'
      ]
      const messagesCount = [
        response?.data?.mostOccurredExceptionMessage?.count,
        response?.data?.secondMostOccurredExceptionMessage?.count > 0
          ? response?.data?.secondMostOccurredExceptionMessage?.count
          : null,
        response?.data?.others?.count
      ]

      setDoughnutChartData({ labels: messagesLabels, counts: messagesCount })

      // Updating store
      store.exceptionsStoreV2.setStatisticsData(response?.data)
      store.exceptionsStoreV2.setStockChartData(
        toPairs(response.data?.responsesByInterval).map(([key, value]) => {
          key = formatDateOfDifferentFormat(key, 'DD/MM/YYYY', 'YYYY-MM-DD')
          return [Number(new Date(key).getTime()), value]
        })
      )

      store.exceptionStore.setIsRefreshed(false)
    } catch (error) {
      console.error('Error fetching exception statistics:', error)
    } finally {
      setLoadingOverview(false)
      setLoadingTag(false)
    }
  }
  useEffect(() => {
    const groupTab = searchParams.get('groupTab')
    if (groupTab === '2' && activeTabIndex !== '2') {
      setActiveIndex('2')
      const queryParams = getAllQueryParamsAsObjectFromUrl(location.search)
      setSearchParams({
        ...queryParams,
        groupTab: '2',
        page: '1'
      })
    }
  }, [location.search])

  const tabOptions = [
    {
      label:
        activeTabIndex === '1' ? (
          <DDSTypography.Title
            type='h5'
            variant='semiBold'
            color={pallete.colors.primary2}
          >
            {'Overview'}
          </DDSTypography.Title>
        ) : (
          <DDSTypography.Title
            type='h5'
            variant='medium'
            color={pallete.colors.textDark5}
          >
            {'Overview'}
          </DDSTypography.Title>
        ),
      children: (
        <div>
          <Overview
            fetchExceptionStatistics={fetchExceptionStatistics}
            exceptionCount={exceptionCount}
            exceptionGroupId={id}
            setLoadingTag={setLoadingTag}
            loadingTag={loadingTag}
            loading={loadingOverview}
            firstReported={firstReported}
            lastReported={lastReported}
            avgPerDay={avgPerDay}
            maximumReport={maximumReport}
            setSearchParamsOverview={setSearchParamsOverview}
            searchParamsOverview={searchParamsOverview}
            activeTabIndex={activeTabIndex}
            fetchAnExceptionDetails={fetchAnExceptionDetails}
            fetchExceptionFiltersOverview={fetchExceptionFiltersOverview}
          />
        </div>
      )
    },
    {
      label:
        activeTabIndex === '2' ? (
          <DDSTypography.Title
            type='h5'
            variant='semiBold'
            color={pallete.colors.primary2}
          >
            {isFullStackProject ? 'Exceptions' : 'Errors'}
          </DDSTypography.Title>
        ) : (
          <DDSTypography.Title
            type='h5'
            variant='medium'
            color={pallete.colors.textDark5}
          >
            {isFullStackProject ? 'Exceptions' : 'Errors'}
          </DDSTypography.Title>
        ),
      children: (
        <GroupedExceptionLogs
          setLoadingDate={setLoadingDate}
          selectedRows={selectedRows}
          fetchAnExceptionDetails={fetchAnExceptionDetails}
          tableData={tableData}
          loading={loadingGroup}
          isSearchTriggered={isSearchTriggered}
          activeTabIndex={activeTabIndex}
          setLoading={setLoadingGroup}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          searchTerm={searchTerm}
          handleSearchChange={handleSearchChange}
          handleSearchEnter={handleSearchEnter}
          setShowDropdown={setShowDropdown}
          showDropdown={showDropdown}
          handleOptionSelect={handleOptionSelect}
          searchParams={searchParamsGroup}
          LogTableColumns={LogTableColumns}
          totalCount={totalCount}
          setSearchParams={setSearchParamsGroup}
          setSelectedRows={setSelectedRows}
          searchRecordLength={searchRecordLength}
          routeExceptionLog={routeExceptionLog}
          updateSeverity={updateSeverity}
          setModalOpen={setModalOpenGroup}
          preference={preferenceGroup}
          modalOpen={modalOpenGroup}
          setActiveSortOrder={setActiveSortOrder}
          setSearchTerm={setSearchTerm}
          fetchAllExceptionLogs={fetchAllExceptionLogs}
          fetchExceptionFilters={fetchExceptionFilters}
          selectedAll={selectedAll}
          setSelectedAll={setSelectedAll}
        />
      )
    }
  ]
  if (
    loading ||
    store.uiStore.getGlobalLoader() ||
    isloadingTag ||
    store.uiStore.getTagLoader()
  )
    return <Spinner />
  return (
    <div className='h-[100%] '>
      <DocumentHeader
        header={
          store.scopeStore.getSelectedProject().type ===
          ProjectType.FULL_STACK_ONLY
            ? HeaderConstants.EXCEPTIONS
            : HeaderConstants.ERROR
        }
      />
      <div className='py-[24px] overflow-x-hidden'>
        <div className='flex flex-row justify-between items-start'>
          <div className='flex gap-y-[8px] flex-col'>
            <div className='relative '>
              <DDSTooltip
                id={generateRandomId()}
                label={exceptionGroupType}
                shape='roundedRectangle'
                position='bottom'
                theme='light'
                className={`border override-tooltip-arrow max-w-full break-all whitespace-normal ${
                  typeof exceptionGroupType === 'string' &&
                  exceptionGroupType.length > 20
                    ? ''
                    : '!hidden'
                }`}
                style={{
                  borderColor: pallete.colors.stroke2,
                  zIndex: 99999,
                  maxWidth: '100%',
                  overflow: 'hidden'
                }}
              >
                <div className='flex justify-start overflow-hidden'>
                  <DDSTypography.Title
                    type='h3'
                    variant='semiBold'
                    className='max-w-[700px] truncate'
                  >
                    {exceptionGroupType}
                  </DDSTypography.Title>
                </div>
              </DDSTooltip>
            </div>
            <div className='flex flex-row items-center gap-x-[4px]'>
              <div>
                <DDSTypography.Paragraph
                  size='caption'
                  variant='medium'
                  style={{ color: pallete.colors.textDark6 }}
                  className='flex items-center whitespace-nowrap'
                >
                  {isFullStackProject ? 'Exception Count:' : 'Error Count:'}
                </DDSTypography.Paragraph>
              </div>
              <div>
                <DDSTypography.Paragraph
                  size='para'
                  variant='semiBold'
                  style={{ color: pallete.colors.textDark3 }}
                  className='whitespace-nowrap text-center flex items-center'
                >
                  {exceptionCount}
                </DDSTypography.Paragraph>
              </div>

              {/* <div>
                {loading || loadingTag || store.uiStore.getGlobalLoader() ? (
                  '-'
                ) : (
                  <div className='flex flex-col top-[14px] gap-y-[16px] relative'>
                    <div className='flex flex-row gap-x-[8px] gap-y-[8px] relative flex-wrap'>
                      {exceptionDetails?.tags?.length > 0
                        ? exceptionDetails.tags
                            ?.slice(0, 5)
                            ?.map((tag: string, index: number) => (
                              <span
                                className='px-[8px] py-[4px] rounded-[100px] flex items-center'
                                key={index}
                                style={{
                                  backgroundColor: pallete.colors.surface4,
                                  cursor:
                                    isloadingTag || store.uiStore.getTagLoader()
                                      ? 'not-allowed'
                                      : 'pointer',
                                  pointerEvents:
                                    isloadingTag || store.uiStore.getTagLoader()
                                      ? 'none'
                                      : 'auto'
                                }}
                              >
                                <DDSTypography.Paragraph
                                  size='caption'
                                  variant='medium'
                                  color={pallete.colors.textDark4}
                                  className='text-center flex items-center'
                                >
                                  {tag}
                                </DDSTypography.Paragraph>
                              </span>
                            ))
                        : '-'}

                      <div className='flex justify-center items-center'>
                        {exceptionDetails?.tags?.length >= 5 ? (
                          <div
                            className='flex items-center justify-center px-[8px] py-[4px] rounded-full cursor-pointer hover:bg-blue-200'
                            style={{ backgroundColor: pallete.colors.surface4 }}
                            onClick={() => {
                              setIsPopupOpen(true)
                            }}
                          >
                            <span
                              style={{
                                fontWeight: 500,
                                fontSize: '12px',
                                color: pallete.colors.textDark4
                              }}
                              className='mr-[8px]'
                            >
                              Edit tags
                            </span>
                            <Edit
                              style={{
                                cursor:
                                  isloadingTag || store.uiStore.getTagLoader()
                                    ? 'not-allowed'
                                    : 'pointer',
                                pointerEvents:
                                  isloadingTag || store.uiStore.getTagLoader()
                                    ? 'none'
                                    : 'auto'
                              }}
                              size={16}
                              color={pallete.colors.FillButton}
                            />
                          </div>
                        ) : (
                          <div
                            className='flex items-center justify-center px-[8px] py-[4px] rounded-full shadow-md cursor-pointer hover:bg-blue-200'
                            style={{ backgroundColor: pallete.colors.surface4 }}
                            onClick={() => {
                              setIsPopupOpen(true)
                            }}
                          >
                            <span
                              style={{
                                fontWeight: 500,
                                fontSize: '12px',
                                color: pallete.colors.textDark4
                              }}
                              className='mr-[8px]'
                            >
                              Add tags
                            </span>
                            <AddFilled
                              style={{
                                cursor:
                                  isloadingTag || store.uiStore.getTagLoader()
                                    ? 'not-allowed'
                                    : 'pointer',
                                pointerEvents:
                                  isloadingTag || store.uiStore.getTagLoader()
                                    ? 'none'
                                    : 'auto'
                              }}
                              size={16}
                              color={pallete.colors.FillButton}
                            />
                          </div>
                        )}
                      </div>
                    </div>

                    <ExceptionGroupedSearchTag
                      isPopupOpen={isPopupOpen}
                      setIsLoadingTag={setIsLoadingTag}
                      isloadingTag={isloadingTag}
                      setIsPopupOpen={setIsPopupOpen}
                      exceptionId={id}
                      exceptionTagData={exceptionDetails?.tags}
                      fetchAnExceptionDetails={fetchAnExceptionDetails}
                    />
                  </div>
                )}
              </div> */}
            </div>
          </div>
        </div>
        <div className='mt-[24px] w-full relative'>
          <Tabs
            tabOptions={tabOptions}
            tabOptionsStyle={{
              minWidth: 'fit-content',
              width: 'auto',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              alignSelf: 'stretch',
              padding: '8px 12px',
              marginRight: '8px'
            }}
            onChange={(value: string) => {
              if (activeTabIndex != value) {
                setActiveIndex(value.toString())
                const queryParams = getAllQueryParamsAsObjectFromUrl(
                  location.search
                )
                delete queryParams['search-string']
                delete queryParams['search-type']
                delete queryParams['searchTerm']
                setSearchParams({
                  ...queryParams,
                  groupTab: value.toString(),
                  page: '1'
                })
              }
            }}
            activeTab={activeTabIndex}
            className='override-tab-active-font'
          />
          <div className='absolute right-0 top-[-100px] flex flex-col gap-y-[8px] space-x-[12px]'>
            <div className='flex space-x-[12px]  justify-end'>
              <div className='relative top-[2px]'>
                <Timezone
                  tooltipText='Time zone is based on organization settings'
                  text={
                    <div>
                      {matchedTimeZone?.tzCode}
                      {''}
                      {''} {matchedTimeZone?.label}
                    </div>
                  }
                  textColor={pallete.colors.neuButtonText}
                />
              </div>
              <Button
                id='refresh-btn'
                type='neutral'
                disabled={
                  loading ||
                  loadingTag ||
                  isloadingTag ||
                  store.uiStore.getTagLoader() ||
                  store.uiStore.getGlobalLoader()
                }
                startIcon={<Renew color={pallete.colors.textDark10} />}
                onClick={() => {
                  gaEventTracker(
                    gaPageConstants.REFRESH_EXCEPTIONS_SINGLE_GROUP
                  )
                  store.exceptionStore.setIsRefreshed(true)
                }}
              />
            </div>
            <div className=' flex flex-row items-center gap-x-[8px]'>
              <div className='flex items-center custom-filter justify-end absolute right-0 top-[102px] space-x-[12px] z-[10]'>
                <Filter
                  options={
                    activeTabIndex === '1'
                      ? filterOptionsOverview
                      : filterOptions
                  }
                  dropdownLoader={
                    activeTabIndex === '1'
                      ? filterLoadingOverview
                      : filterLoading
                  }
                  primaryText='Add Filters'
                  APITimeFormat={true}
                  hideFilterChipAPI={true}
                  clearFilterDisabled={true}
                  isScrollable={true}
                />
                {!(
                  loading ||
                  loadingDate ||
                  loadingOverview ||
                  store.uiStore.getGlobalLoader() ||
                  store.uiStore.getprojectEnvironmentLoader()
                ) ? (
                  <SideChip
                    id='date-range-chip'
                    label='Date Range'
                    value={
                      activeTabIndex === '1'
                        ? convertToFormat(dateFilterOverview, orgTimeZone)
                        : convertToFormat(dateFilter, orgTimeZone)
                    }
                  />
                ) : null}
              </div>
            </div>

            <div className=' flex flex-row items-center gap-x-[8px]'>
              <DDSTypography.Title
                type='h5'
                variant='semiBold'
                style={{ color: pallete.colors.textDark4 }}
              >
                Default Group Severity :
              </DDSTypography.Title>
              {preference && (
                <div className='override-single-log-severity relative flex items-center'>
                  <SeverityDropDown
                    label={preference}
                    onSelect={(value: SeverityTypes) => {
                      if (value !== preference) {
                        setToPreference(value)
                        setModalOpen(true)
                      }
                    }}
                    insideTable={false}
                    disableNoSubscription={
                      store.userStore.getNoActiveSubscription() ||
                      loading ||
                      // loadingTag ||
                      // isloadingTag ||
                      store.uiStore.getTagLoader() ||
                      store.uiStore.getGlobalLoader()
                    }
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <ConfirmationPopup
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        title='Severity Type'
        primaryButtonClick={() =>
          updateExceptionGroupPreferrence(changeToPreference)
        }
        secondaryButtonClick={() => {
          setModalOpen(false)
          setApplyToExisting(null)
        }}
        loading={loading}
        primaryButtonText='Confirm'
        secondaryButtonText='Cancel'
        primaryButtonDisabled={loading || applyToExisting === null}
        secondaryButtonDisabled={loading}
        onIconClose={handleModalClose}
        content={
          <div className='flex flex-col w-full gap-y-[24px] items-center justify-center '>
            <DDSTypography.Title
              variant='medium'
              type='h5'
              className='text-left'
              color={pallete.colors.textDark11}
            >
              {`Would you like this new severity to apply only to new incoming ${isFullStackProject ? 'exceptions' : 'errors'}, or also to existing ${isFullStackProject ? 'exceptions' : 'errors'} in this group?`}
            </DDSTypography.Title>

            <DDSTypography.Title
              variant='medium'
              type='h5'
              className='text-left'
              color={pallete.colors.textDark11}
            >
              Updating existing {isFullStackProject ? 'exceptions' : 'errors'}{' '}
              will override their current severity values.
            </DDSTypography.Title>

            <DDSTypography.Title
              variant='semiBold'
              type='h5'
              className='text-left'
            >
              {`Choose how you'd like to apply this change:`}
            </DDSTypography.Title>
            <div className='flex flex-col items-start w-full'>
              <DDSRadio
                checked={applyToExisting === false}
                onChange={() => setApplyToExisting(false)}
                label={
                  <DDSTypography.Title
                    type='h5'
                    variant='medium'
                    className='pl-[8px]'
                    color={pallete.colors.textDark3}
                  >
                    {`Apply to new ${isFullStackProject ? 'exceptions' : 'errors'} only`}
                  </DDSTypography.Title>
                }
              ></DDSRadio>
              <DDSTypography.Paragraph
                size='para'
                variant='regular'
                className='pl-[24px]'
                color={pallete.colors.textDark4}
              >
                {`Keep current severity for existing ${isFullStackProject ? 'exceptions' : 'errors'}`}
              </DDSTypography.Paragraph>
            </div>
            <div className='flex flex-col items-start w-full'>
              <DDSRadio
                checked={applyToExisting === true}
                onChange={() => setApplyToExisting(true)}
                label={
                  <DDSTypography.Title
                    type='h5'
                    variant='medium'
                    className='pl-[8px]'
                    color={pallete.colors.textDark3}
                  >
                    {`Apply to all ${isFullStackProject ? 'exceptions' : 'errors'}`}
                  </DDSTypography.Title>
                }
              ></DDSRadio>
              <DDSTypography.Paragraph
                size='para'
                variant='regular'
                className='pl-[24px]'
                color={pallete.colors.textDark4}
              >
                {`Update severity for both existing and new ${isFullStackProject ? 'exceptions' : 'errors'} in this group`}
              </DDSTypography.Paragraph>
            </div>
          </div>
        }
      />
    </div>
  )
}
export default observer(SingleExceptionView)
